module.exports = __webpack_public_path__ + "img/tanom4.abffc807.png";